import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "message-drawer-heading" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "校园私信")
], -1)

import { onMounted, onBeforeUnmount } from "vue";
import PrivateMessage from "@/components/PrivateMessage/index.vue";
import usePrivateMessageStore from "@/store/modules/privateMessage";
import { GET_ID } from "@/utils/token";

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const chat = usePrivateMessageStore();
let timer: ReturnType<typeof setInterval>;
const poll = () => {
  if (document.visibilityState === "visible") void chat.refresh();
};
const syncStorage = (event: StorageEvent) => {
  if (event.key === `market:private-read:${chat.owner}`) chat.syncReadStorage();
};
onMounted(() => {
  chat.reset(GET_ID() || "");
  poll();
  timer = setInterval(poll, 8000);
  document.addEventListener("visibilitychange", poll);
  window.addEventListener("online", poll);
  window.addEventListener("storage", syncStorage);
});
onBeforeUnmount(() => {
  clearInterval(timer);
  document.removeEventListener("visibilitychange", poll);
  window.removeEventListener("online", poll);
  window.removeEventListener("storage", syncStorage);
  chat.reset();
});

return (_ctx: any,_cache: any) => {
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    modelValue: _unref(chat).opened,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(chat).opened) = $event)),
    title: "校园私信",
    direction: "rtl",
    size: "min(860px, 100vw)",
    class: "campus-message-drawer",
    "append-to-body": "",
    "destroy-on-close": ""
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _createVNode(PrivateMessage)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})